import getMeta from '@atlassian/jira-get-meta';
import transformSubProducts from '../transform-sub-products/index.tsx';

const getApplicationSubProduct = () => transformSubProducts(getMeta('ajs-application-key'));

export default getApplicationSubProduct;
